export default __webpack_public_path__ + "static/media/panelM3.51969202.png";